import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("locations")
export class LocationModel extends BaseEntity {
  latitude: number;
  longitude: number;
}
